import { createTestIds } from '../../utils';

export const getBannerTestIds = createTestIds('banner', [
  'heading',
  'expand-collapse',
  'dismiss',
  'message-label',
  'message-description',
  'message-action'
] as const);
